import { FC, HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
	store: Store;
	iconEvent?: () => void;
	icon?: ReactNode;
}

const StoreSearchItem: FC<Props> = ({
	store,
	icon,
	iconEvent,
	className,
	...restProps
}) => {
	return (
		<div
			role="listitem"
			aria-label={`store-${store.name}`}
			className={`flex-1 ${className ?? ""}`}
			{...restProps}
		>
			<div className="flex items-center gap-2">
				<div className="flex flex-col flex-1 ml-2">
					<p className="font-bold" aria-label="user-name">
						{store.name}
					</p>
				</div>

				{icon && (
					<button onClick={iconEvent} type="button">
						{icon}
					</button>
				)}
			</div>
		</div>
	);
};

export default StoreSearchItem;
